<template>
  <div class="RegisterCardStyle">
    <UserBase :title="title" :isShowToLogin="isShowToLogin">
      <template #default>
        <v-row no-gutters class="pb-2" justify="center" align-content="center">
          <v-col cols="10" class="text-center">
            メンテナンス中です。<br />時間を空けてご利用ください。
          </v-col>
        </v-row>
      </template>
    </UserBase>
  </div>
</template>
<script>
import UserBase from '@/components/layouts/UserBase/UserBase'

export default {
  components: {
    UserBase
  },
  props: {
    title: { default: 'メンテナンス中' },
    isShowToLogin: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      //
    }
  },
  methods: {}
}
</script>
